import * as React from "react";
import { memo } from "react";
const SvgInfo = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" {...props}>
    <g data-name="Layer 2">
      <g data-name="Layer 1">
        <circle
          cx={50}
          cy={50}
          r={46.5}
          fill="none"
          stroke="currentColor"
          className="info_svg__cls-1"
          style={{
            strokeMiterlimit: 10,
            strokeWidth: 7,
          }}
        />
        <path
          fill="currentColor"
          d="M50 25a4.49 4.49 0 0 1 4.51 4.5A4.43 4.43 0 0 1 50 33.92a4.36 4.36 0 0 1-4.43-4.43A4.42 4.42 0 0 1 50 25Zm-3.39 16.43h6.78V75h-6.78Z"
        />
      </g>
    </g>
  </svg>
);
const Memo = memo(SvgInfo);
export default Memo;

